export default {
    edit: "Bearbeiten",
    select: "Auswählen",
    restore: "Wiederherstellen",
    addNewParticipant: "Neuen Teilnehmenden hinzufügen",
    addNewCaregiver: "Neuen Betreuer hinzufügen",
    addNewPerson: "Neue Person hinzufügen",
    noRemainingPlacesLeft: "Keine weiteren Plätze verfügbar",
    canNotRestore: "Teilnehmer kann nicht wiederhergestellt werden, da keine weiteren Plätze für diese Veranstaltung verfügbar sind.",
    participantNumber: "Teilnehmer #",
    caregiverNumber: "Betreuer #",
    personNumber: "Person #",
    noName: "Kein Name angegeben",
    done: "Fertig",
    personDeleted: "Diese Person wurde entfernt.",
    caregiverDeleted: "Dieser Betreuer wurde entfernt.",
    participantDeleted: "Dieser Teilnehmer wurde entfernt.",
}
